import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/public.request";
import {getQueryString} from "../../../util/query";

export const getPaginatedGamesService = async ({
  page = 1,
  limit = 48,
  provider = "",
  class: classFilter = "",
  subclass = "",
  search = "",
}) => {
  const queryString = getQueryString({
    page,
    limit,
    provider: provider === "all" ? "" : provider,
    class: classFilter,
    sub_class: subclass,
    search,
  });

  return publicRequest.get(`${ConfEnv.API_URL.GAMES_PAGINATED}${queryString}`);
};
